export enum ActiveTab {
  Quotes = 'quotes',
  Orders = 'orders',
  LNOrders = 'ln-orders',
  Invoices = 'invoices'
}

export enum ActiveTabIndex {
  OpenQuotes = 0,
  TransactionHistory = 1,
  LNOrders = 2,
  Invoices = 3
}

export function getActiveTabIndex(activeTab: string): ActiveTabIndex {
  switch (activeTab) {
    case ActiveTab.Quotes:
      return ActiveTabIndex.OpenQuotes;
    case ActiveTab.Orders:
      return ActiveTabIndex.TransactionHistory;
    case ActiveTab.LNOrders:
      return ActiveTabIndex.LNOrders;
    case ActiveTab.Invoices:
      return ActiveTabIndex.Invoices;
    default:
      return ActiveTabIndex.OpenQuotes;
  }
}
